angular.module('qkr').directive('pagination', (paginationService, $window) => ({
    restrict: 'E',
    template: require('../../directives/pagination/pagination_template.html'),
    scope: {
        count: '=count',
        reloadItemsFunction: '=reloadItemsFunction',
        filters: '=filters'
    },
    transclude: true,
    link(scope, elem, attrs) {
        scope.maxList = {
            list: [10, 20, 30, 50],
            selected: 10
        };

        const getPageInfo = function(totalItems, currentPage, pageSize) {
            const pageInfo = paginationService.getPages(totalItems, currentPage, pageSize);
            scope.pages = pageInfo.pages;
            scope.currentPage = pageInfo.currentPage;
            scope.totalPages = pageInfo.totalPages;
        };

        scope.reloadItems = function(currentPage, offset, max) {
            scope.reloadItemsFunction(offset, max);
            getPageInfo(scope.count, currentPage, scope.maxList.selected);
        };

        scope.pageChanged = function(selectedPage, disabled) {
            if (!disabled) {
                scope.currentPage = selectedPage;
                scope.reloadItems(selectedPage, (selectedPage - 1) * scope.maxList.selected, scope.maxList.selected);
                $window.scrollTo(0,0);
            }
        };

        scope.$watchCollection("filters", (newVal, oldVal) => {
            //set current page back to 1 after filters change
            scope.currentPage = 1;
        });

        scope.$watchCollection("count", (newVal, oldVal) => {
            getPageInfo(scope.count, null, scope.maxList.selected);
        });
    }
}));



// WEBPACK FOOTER //
// ./src/directives/pagination/pagination.js